import { useState } from 'react'
import ReactionStyled from './reaction-styled'

function Reaction({
  action,
  message,
  count,
  reactionCounter,
  reaction,
  reacted,
  onReaction,
  ...otherProps
}) {
  const [animated, setAnimated] = useState(false)
  const handleReaction = () => {
    setAnimated(true)
    onReaction(reaction, reactionCounter)
  }
  return (
    <ReactionStyled
      reaction={reaction}
      reacted={reacted}
      onClick={handleReaction}
      animated={animated}
      data-cy={reaction}
      {...otherProps}
    >
      <div className="action__container">
        <div className={
          reacted
            ? `reaction step-${reaction}-animated reaction-animation`
            : `reaction step-${reaction}`
        }
        />
        {count > 0 && (
          <span data-cy="reaction-count">{count}</span>
        )}
        <div className="arrow_container">
          <p className="arrow_box">{message}</p>
        </div>
      </div>
    </ReactionStyled>
  )
}

export default Reaction
